import React,{useState} from "react";
import CssBaseline from "@mui/material/CssBaseline";
import {Modal, Button,Grid, Typography, Card, CardMedia} from "@mui/material";
import BmjLogo from "../assets/logo/bmjLogo.svg";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import CloseIcon from "@mui/icons-material/Close";
import ContactForm from "./ContactForm";
import bmjVideo from "../assets/video/bmj-video.mp4"

function ElevationScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
}

const Header = () => {
    const [open, setOpen] = useState(false);


  const handleOpenModal = () => setOpen(true);
  const handleCloseModal = () => setOpen(false);
  return (
  <>
  <Modal
        open={open}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Grid container className="modal-container">
          <Grid item xs={12}>
            <Button className="modal-close-btn" onClick={handleCloseModal}>
              {/* CloseIcon here */} 
              <CloseIcon />
            </Button>
          </Grid>


          <Grid item xs={12} className='modal-body'>
           <ContactForm/>
          </Grid>

        </Grid>
      </Modal>
    <CssBaseline />
    <ElevationScroll >
      <AppBar style={{ backgroundColor: "transparent" }}>
        <Toolbar>
          <Grid container columnSpacing={3} className="nav-container">
            <Grid item xs={4} md={3} display="flex" justifyContent="flex-start" alignItems="center">
                <Typography
                  display={{ xs: "none", md: "block" }}
                  variant="subtitle1"
                  component="h6"
                  onClick={handleOpenModal}
                >
                  Call now: +91-9711765512
                </Typography>
            </Grid>
            <Grid item xs={4} md={6} className="logo-container">
              <img src={BmjLogo} alt="Bmj Logo" height="auto" width="100%" />
            </Grid>
            <Grid item xs={4}  md={3} className="nav-items">
                <Typography
                  display={{ xs: "none", md: "block" }}
                  variant="subtitle1"
                  component="h6"
                  sx={{cursor:"pointer", 
                  borderRadius:"20px", 
                  backgroundColor:"#ca3557", 
                  paddingX:"0.7em", 
                  paddingY:"0.2em", 
                  boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px"}}
                  onClick={handleOpenModal}
                >
                  Join the waitlist

                </Typography>
                <Typography
                  display={{ xs: "block", md: "none" }}
                  variant="subtitle2"
                  component="subtitle1"
                  sx={{cursor:"pointer", 
                  borderRadius:"20px", 
                  backgroundColor:"#ca3557", 
                  paddingX:"0.7em", 
                  paddingY:"0.2em", 
                  boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
                textAlign:"center", marginTop:"0.5em"}}
                  onClick={handleOpenModal}
                >
                  Join the waitlist

                </Typography>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </ElevationScroll>

      {/* <Grid container>
        <Grid item xs={12}>
          <Grid container>
            <Grid item md={2}></Grid>
            <Grid item xs={12}>
              <Card raised={true} sx={{ maxWidth: 400 }}>
                <CardMedia
                  component="video"
                  autoPlay
                  controls
                  src={bmjVideo}
                />

              </Card>
            </Grid>
            <Grid item md={2}></Grid>
          </Grid>
        </Grid>
      </Grid> */}
  </>
  )
}

export default Header